import { useBeacon } from '~/composables/useBeacon'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public
  if (!config.userActivityTrackingEnabled) return

  const authStore = useAuthStore()
  const beacon = useBeacon()

  const sendLogin = (licenceId: string): void => {
    beacon
      .sendUserActivity({ event_type: 'login', metadata: { new_licence_id: licenceId } })
      .then(({ session_id }) => {
        if (session_id) authStore.setSessionId(session_id)
      })
      .catch((err) => console.error('Failed to send login activity', err))
  }

  if (authStore.isAuthenticated && authStore.activeLicence && !authStore.sessionId) {
    sendLogin(String(authStore.activeLicence.id))
  }

  watch(
    () => authStore.isAuthenticated,
    (isAuthenticated) => {
      if (isAuthenticated && authStore.activeLicence) {
        sendLogin(String(authStore.activeLicence.id))
      }
    }
  )

  watch(
    () => authStore.activeLicence,
    (licence) => {
      if (!licence || !authStore.isAuthenticated) return

      const isSwitch = !!authStore.lastActiveLicence && authStore.lastActiveLicence.id !== licence.id
      if (isSwitch) {
        const oldSessionId = authStore.sessionId
        authStore.clearSessionId()
        beacon
          .sendUserActivity({
            ...(oldSessionId ? { session_id: oldSessionId } : {}),
            event_type: 'switch_license',
            metadata: { new_licence_id: String(licence.id) }
          })
          .then(({ session_id }) => {
            if (session_id) authStore.setSessionId(session_id)
          })
          .catch((err) => console.error('Failed to send switch_license activity', err))
      } else if (!authStore.sessionId) {
        sendLogin(String(licence.id))
      }
    }
  )
})
